var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "problem-definition" }, [
      _c("div", { staticClass: "problem-option" }, [
        _c("strong", {
          domProps: { textContent: _vm._s(_vm.$t("error.problem.type")) },
        }),
        _vm._v(" "),
        _c("p", { staticClass: "problem-option-text" }, [
          _vm._v(" " + _vm._s(_vm.tipo)),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "problem-option" }, [
        _c("strong", {
          domProps: { textContent: _vm._s(_vm.$t("error.problem.detail")) },
        }),
        _vm._v(" "),
        _c("p", { staticClass: "problem-option-text" }, [
          _vm._v(" " + _vm._s(_vm.detail)),
        ]),
      ]),
      _vm._v(" "),
      _vm.instancia
        ? _c("div", { staticClass: "problem-option" }, [
            _c("strong", {
              domProps: {
                textContent: _vm._s(_vm.$t("error.problem.instance")),
              },
            }),
            _vm._v(" "),
            _c("p", { staticClass: "problem-option-text" }, [
              _vm._v(" " + _vm._s(_vm.instancia)),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.extensionMembers
        ? _c(
            "div",
            { staticClass: "problem-extension" },
            _vm._l(_vm.extensionMembers, function (member) {
              return _c("div", { staticClass: "problem-option" }, [
                _c("strong", { domProps: { textContent: _vm._s(member[0]) } }),
                _vm._v(" "),
                _c("p", { staticClass: "problem-option-text" }, [
                  _vm._v(" " + _vm._s(member[1])),
                ]),
              ])
            }),
            0
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }